import { z } from 'zod';
import { InputJsonValue } from "../inputTypeSchemas/InputJsonValue"

/////////////////////////////////////////
// NOTIFY CONTENT SCHEMA
/////////////////////////////////////////

export const NotifyContentSchema = z.object({
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  publishedAt: z.coerce.date().nullable(),
  expiredAt: z.coerce.date().nullable(),
  deactivatedAt: z.coerce.date().nullable(),
  lastNotifiedAt: z.coerce.date().nullable(),
  scheduledAt: z.coerce.date().nullable(),
  headline: z.string(),
  tagline: z.string().nullable(),
  body: z.string(),
  isDraft: z.boolean(),
  channels: InputJsonValue,
  authorId: z.number().int(),
  voiceBody: z.string().nullable(),
  voiceForceSendAll: z.boolean().nullable(),
  voiceAudioResourceId: z.number().int().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type NotifyContent = z.infer<typeof NotifyContentSchema>

export default NotifyContentSchema;
